// Pure helpers extracted from ProductManagement.js

export const totalStock = (skus) =>
  (skus || []).reduce((sum, s) => sum + (s.current_stock || 0), 0);

export const totalReserved = (skus) =>
  (skus || []).reduce((sum, s) => sum + (s.reserved_stock || 0), 0);

export const totalAvailable = (skus) =>
  (skus || []).reduce(
    (sum, s) => sum + Math.max(0, (s.current_stock || 0) - (s.reserved_stock || 0)),
    0
  );

export const getWspRange = (skus) => {
  if (!skus || skus.length === 0) return null;
  const prices = skus.map((s) => s.mrp).filter(Boolean);
  if (prices.length === 0) return null;
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  return min === max
    ? `₹${min.toLocaleString('en-IN')}`
    : `₹${min.toLocaleString('en-IN')} - ₹${max.toLocaleString('en-IN')}`;
};

// A "forwarding sample" is a design that can be ordered before goods physically
// arrive: a tentative WSP is set AND no Purchase Entry has received stock yet.
// Once a PE runs (last_stock_date gets set), it is no longer forwarding.
export const isForwarding = (product) =>
  !!(product && product.tentative_wsp && product.tentative_wsp > 0) && !product?.last_stock_date;

export const getAgingDays = (product) => {
  const refDate = product.last_stock_date || product.date_added;
  if (!refDate) return null;
  const diff = Date.now() - new Date(refDate).getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
};
